import icon from "../../../assets/images/icon_circle_progress.svg";
import iconGray from "../../../assets/images/icon_circle_progress_gray.svg";

type Props = {
    className?: string;
};

export default {
    Bronze: ({ className }: Props) => {
        return <img src={icon} className={className ? className : "h-4 w-4"} />;
    },
    Stone: ({ className }: Props) => {
        return <img src={iconGray} className={className ? className : "h-4 w-4"} />;
    }
};
